import { connect } from "react-redux";
import Profile from "./profile";
import { bindActionCreators } from "redux";
const mapStateToProps = (state) => ({
    userProfile : state.loginReducer.userProfile
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
